import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-8 space-y-5" }
const _hoisted_4 = { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_5 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_6 = { class: "text-2xl font-bold md:text-4xl" }
const _hoisted_7 = { class: "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_8 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_11 = { class: "flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5" }
const _hoisted_12 = { class: "text-base font-bold text-slate-900" }
const _hoisted_13 = { class: "text-xs text-slate-500" }
const _hoisted_14 = { class: "overflow-x-auto" }
const _hoisted_15 = { class: "min-w-full text-sm" }
const _hoisted_16 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  colspan: "7",
  class: "px-6 py-12 text-sm text-center text-slate-400 italic"
}
const _hoisted_20 = { class: "px-4 py-3 text-slate-500 align-middle" }
const _hoisted_21 = { class: "px-4 py-3 align-middle" }
const _hoisted_22 = { class: "font-bold text-slate-900" }
const _hoisted_23 = { class: "px-4 py-3 align-middle" }
const _hoisted_24 = { class: "text-sm text-slate-600 font-medium" }
const _hoisted_25 = { class: "text-[11px] text-slate-400" }
const _hoisted_26 = { class: "px-4 py-3 align-middle" }
const _hoisted_27 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold bg-blue-50 text-blue-700 border border-blue-100 uppercase" }
const _hoisted_28 = { class: "px-4 py-3 align-middle" }
const _hoisted_29 = { class: "text-sm text-slate-700 font-medium whitespace-nowrap" }
const _hoisted_30 = { class: "px-4 py-3 align-middle text-right" }
const _hoisted_31 = { class: "text-sm font-bold text-indigo-700" }
const _hoisted_32 = { class: "px-4 py-3 align-middle text-center" }
const _hoisted_33 = { class: "flex items-center justify-center gap-1" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex flex-col items-center justify-between gap-3 border-t border-slate-100 px-6 py-4 sm:flex-row" }
const _hoisted_37 = { class: "text-xs font-medium text-slate-500 xs:text-sm" }
const _hoisted_38 = { class: "text-slate-900 font-bold" }
const _hoisted_39 = { class: "text-slate-900 font-bold" }
const _hoisted_40 = { class: "text-slate-900 font-bold" }
const _hoisted_41 = { class: "inline-flex gap-2" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import { GET_DANA_BANTUAN, DELETE_DANA_BANTUAN } from "@/store/danaBantuan.module";
import ModalForm from "../components/modal/FormDanaBantuan.vue";
import { formattedPrice } from '@/utils';
import IcTrash from '@/assets/svg/ic-trash.vue';
import IcEdit from '@/assets/svg/ic-edit.vue';
import IcPlus from '@/assets/svg/ic-plus.vue';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DanaBantuan',
  setup(__props) {

const store = useStore();

const title = ref("Dana Bantuan");
const isLoading = ref(true);
const isOpened = ref(false);
const currentId = ref<string | undefined>(undefined);
const dataUpdate = ref<any>([]);
const isImageModalOpen = ref(false);
const selectedImage = ref('');
const page = ref(1);
const limit = ref(10);
const search = ref("");

const pageLimitOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
];

const openModal = () => {
  currentId.value = undefined;
  dataUpdate.value = [];
  isOpened.value = true;
};

const handleModalClose = async () => {
  isOpened.value = false;
  currentId.value = undefined;
  dataUpdate.value = [];
  await getData();
};

const computedData = computed(() => {
  const data = store.getters.danaBantuan;
  return data.data || [];
});

const pagination = computed(() => {
  const data = store.getters.danaBantuan;
  return data?.pagination || {};
});

const getData = async () => {
  isLoading.value = true;
  try {
    const params = {
      data: {
        search: search.value,
        limit: limit.value,
        page: page.value,
      }
    };
    await store.dispatch(GET_DANA_BANTUAN, params);
  } finally {
    isLoading.value = false;
  }
};

onMounted(getData);

const closeImageModal = () => {
  isImageModalOpen.value = false;
};

const editItem = (item: any) => {
  dataUpdate.value = { ...item };
  currentId.value = item.id;
  isOpened.value = true;
};

const deleteItem = async (id: number) => {
  const result = await Swal.fire({
    title: 'Hapus data?',
    text: "Data yang dihapus tidak dapat dikembalikan!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#8c8c94',
    confirmButtonText: 'Ya, hapus!',
    cancelButtonText: 'Batal'
  });

  if (result.isConfirmed) {
    try {
      await store.dispatch(DELETE_DANA_BANTUAN, { id });
      await Swal.fire({
        title: "Terhapus!",
        text: "Data dana bantuan berhasil dihapus.",
        icon: "success",
        confirmButtonColor: '#003793',
      });
      await getData();
    } catch (err: any) {
      console.error(err);
      Swal.fire('Gagal', 'Gagal menghapus data', 'error');
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: title.value }, null, 8, ["breadcrumb"]),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value? 'Edit' : 'Tambah'} ${title.value}`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: closeImageModal,
          class: "fixed inset-0 flex items-center justify-center bg-black/60 z-50 p-6"
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Payment Image",
            class: "max-w-full max-h-full rounded-lg shadow-xl"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(title.value), 1),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola pencatatan penyaluran dana bantuan kepada mahasiswa penerima manfaat. ", -1))
          ]),
          _createElementVNode("button", {
            class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
            onClick: openModal
          }, [
            _createVNode(IcPlus, { class: "w-4 h-4" }),
            _createTextVNode(" Tambah " + _toDisplayString(title.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Per halaman", -1)),
            _createVNode(AppSelect, {
              modelValue: limit.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event)),
              options: pageLimitOptions,
              onChange: _cache[1] || (_cache[1] = () => { page.value = 1; getData() })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari Penerima", -1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-3" }, [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  class: "w-4 h-4 text-slate-400",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                onInput: _cache[3] || (_cache[3] = () => { page.value = 1; getData() }),
                placeholder: "Nama atau NIM...",
                class: "block w-full rounded-lg border border-slate-200 bg-white px-10 py-2 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_12, "Daftar " + _toDisplayString(title.value), 1),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Menampilkan histori penyaluran dana bantuan.", -1))
          ]),
          _createElementVNode("span", _hoisted_13, "Halaman " + _toDisplayString(pagination.value?.currentPage || page.value) + " dari " + _toDisplayString(pagination.value?.totalPages || 1), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-blue-900" }, [
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "No"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Penerima"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "NIM / Prodi"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Jenis Bantuan"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100 uppercase tracking-wider" }, "Periode"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100 uppercase tracking-wider" }, "Nominal"),
                _createElementVNode("th", { class: "px-6 py-3.5 text-sm font-semibold text-center text-blue-100 uppercase tracking-wider" }, "Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_16, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "px-6 py-10 text-center"
                    }, [
                      _createElementVNode("div", { class: "flex flex-col items-center justify-center gap-2" }, [
                        _createElementVNode("div", { class: "h-6 w-6 animate-spin rounded-full border-2 border-[#003793] border-t-transparent" }),
                        _createElementVNode("p", { class: "text-sm font-medium text-slate-500" }, "Memuat data...")
                      ])
                    ], -1)
                  ]))]))
                : (computedData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                      _createElementVNode("td", _hoisted_19, " Belum ada data " + _toDisplayString(title.value.toLowerCase()) + ". ", 1)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(computedData.value, (u, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: u.id || index,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_20, _toDisplayString(((pagination.value?.currentPage - 1) * limit.value) + (index + 1)), 1),
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("p", _hoisted_22, _toDisplayString(u?.penerima?.nama || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("p", _hoisted_24, _toDisplayString(u?.penerima?.nim || '-'), 1),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(u?.penerima?.program_studi || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(u?.jenis_bantuan), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(u?.bulan) + " " + _toDisplayString(u?.tahun), 1)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(formattedPrice)(u?.jumlah_donasi)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                              class: "p-1.5 text-amber-600 hover:bg-amber-50 rounded-lg transition-colors",
                              title: "Edit",
                              onClick: _withModifiers(($event: any) => (editItem(u)), ["prevent"])
                            }, [
                              _createVNode(IcEdit, { class: "w-4 h-4" })
                            ], 8, _hoisted_34),
                            _createElementVNode("button", {
                              class: "p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors",
                              title: "Hapus",
                              onClick: _withModifiers(($event: any) => (deleteItem(u.id)), ["prevent"])
                            }, [
                              _createVNode(IcTrash, { class: "w-4 h-4" })
                            ], 8, _hoisted_35)
                          ])
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, [
            _cache[15] || (_cache[15] = _createTextVNode(" Menampilkan ", -1)),
            _createElementVNode("span", _hoisted_38, _toDisplayString(pagination.value?.start || 0), 1),
            _cache[16] || (_cache[16] = _createTextVNode(" sampai ", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(pagination.value?.end || 0), 1),
            _cache[17] || (_cache[17] = _createTextVNode(" dari ", -1)),
            _createElementVNode("span", _hoisted_40, _toDisplayString(pagination.value?.totalEntries || 0), 1),
            _cache[18] || (_cache[18] = _createTextVNode(" data ", -1))
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              class: "inline-flex items-center px-4 py-1.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors",
              disabled: page.value <= 1,
              onClick: _cache[4] || (_cache[4] = ()=>{page.value = (pagination.value?.currentPage || 1) - 1; getData()})
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                class: "w-4 h-4 mr-1",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M15 19l-7-7 7-7"
                })
              ], -1),
              _createTextVNode(" Sebelumnya ", -1)
            ]))], 8, _hoisted_42),
            _createElementVNode("button", {
              class: "inline-flex items-center px-4 py-1.5 text-sm font-bold text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors",
              disabled: page.value >= (pagination.value?.totalPages || 1),
              onClick: _cache[5] || (_cache[5] = ()=>{page.value = (pagination.value?.currentPage || 1) + 1; getData()})
            }, [...(_cache[20] || (_cache[20] = [
              _createTextVNode(" Berikutnya ", -1),
              _createElementVNode("svg", {
                class: "w-4 h-4 ml-1",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 5l7 7-7 7"
                })
              ], -1)
            ]))], 8, _hoisted_43)
          ])
        ])
      ])
    ])
  ]))
}
}

})